<pcs-select [label]="label"
            [labelDetails]="getLabelDetails()"
            [searchTerm]="searchTerm"
            [inputId]="inputId"
            [name]="name"
            [placeholder]="getPlaceholder()"
            [tabindex]="tabindex"
            [disabled]="disabled"
            [readonly]="readonly"
            [horizontal]="horizontal"
            [inputSize]="size"
            [labelSize]="labelSize"
            [loading]="isLoading()"
            [tooltipForValue]="tooltipForValue"
            [focused]="focused"
            (selectChange)="onChange($event)"
            (selectKeyPress)="onKeyPress()"
            (selectKeyDown)="onKeyDown($event)"
            (selectBlur)="onBlur($event)"
            (selectFocus)="onFocus()">

  <pcs-multi-select-badge [text]="numberOfSelectedValues()"
                          [clickable]="hasSelectedValues() && !disabled"
                          (badgeClick)="showSelectedOptions()">
  </pcs-multi-select-badge>

  <pcs-select-menu *ngIf="this.shouldShowSelectionMenu() || this.shouldShowSelected()"
                   [container]="container"
                   (closed)="hide()"
                   tabindex="-1">
    <ng-template>
      <pcs-select-item *ngIf="showSelectAll()"
                       class="dropdown-item"
                       [active]="isActive()">
        <input tabindex="-1"
               type="checkbox"
               class="check"
               [checked]="isFirstSelected()"
               id="{{inputId}}-selectFirst"
               (change)="selectFirstOption()"/>
        <label for="{{inputId}}-selectFirst">
          [select all]
        </label>
      </pcs-select-item>

      <pcs-select-item class="dropdown-item"
                       *ngFor="let option of getVisibleOptions(); let index = index;"
                       [active]="isActive(index) && !disabledForSelection(option)"
                       [disabled]="disabledForSelection(option)">
        <input tabindex="-1"
               type="checkbox"
               class="check"
               id="{{inputId}}-{{index}}"
               [checked]="isSelected(option)"
               [disabled]="disabledForSelection(option)"
               (change)="selectOption(option)"/>
        <label for="{{inputId}}-{{index}}"
               title="{{getOptionValueWithAdditionalProperties(option)}}"
               class="text-wrap">
          {{getOptionValueWithAdditionalProperties(option)}}
        </label>
      </pcs-select-item>
    </ng-template>
  </pcs-select-menu>
</pcs-select>
